import { render, staticRenderFns } from "./FGCView.vue?vue&type=template&id=363dd2dc"
import script from "./FGCView.vue?vue&type=script&lang=js"
export * from "./FGCView.vue?vue&type=script&lang=js"
import style0 from "./FGCView.vue?vue&type=style&index=0&id=363dd2dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports